import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { useSession } from '@/lib/auth';
import { getUsernameCanEdit } from '@/lib/api/core';

/**
 * useCanEditUsername — gate de edición de username vía
 * `GET /v1/profile/username/can-edit` (cierre de GAP-03).
 *
 * El backend valida la regla de "una sola edición": devuelve `can_edit=false`
 * cuando el usuario ya cambió su username una vez. Si el endpoint falla,
 * degradamos a `false` (read-only) para no habilitar una escritura que el
 * server podría rechazar.
 */
export function useCanEditUsername(): UseQueryResult<boolean> {
  const { user } = useSession();
  return useQuery({
    queryKey: ['can-edit-username', user?.id ?? 'anon'],
    queryFn: () => getUsernameCanEdit().catch(() => false),
    enabled: !!user?.id,
    staleTime: 30_000,
  });
}
